import { Controller } from "@hotwired/stimulus"

// Internal pages for the native-popover filter menu. The filters themselves
// are ordinary links and live in the URL; this controller only moves between
// the list of fields and one field's values.
export default class extends Controller {
  static targets = ["page"]
  static values = { page: { type: String, default: "root" } }

  connect() {
    this.popover = this.element.closest("[popover]")
    this.popover?.addEventListener("toggle", this.resetWhenClosed)
    this.render()
  }

  disconnect() {
    this.popover?.removeEventListener("toggle", this.resetWhenClosed)
  }

  open(event) {
    event.preventDefault()
    this.pageValue = event.params.page
  }

  back(event) {
    event.preventDefault()
    this.pageValue = "root"
  }

  pageValueChanged() {
    this.render()
  }

  resetWhenClosed = (event) => {
    if (event.newState === "closed") this.pageValue = "root"
  }

  render() {
    this.pageTargets.forEach((page) => {
      page.hidden = page.dataset.page !== this.pageValue
    })

    requestAnimationFrame(() => {
      const active = this.pageTargets.find((page) => !page.hidden)
      active?.querySelector("[role=menuitem], button, a")?.focus()
    })
  }
}
